// extracted by mini-css-extract-plugin
export var card = "_9o-0";
export var failedIcon = "_9o-4";
export var failedIconBadge = "_9o-3";
export var icon = "_9o-1";
export var successIcon = "_9o-2";